import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ENVIRONMENT_CONFIG, EnvironmentConfiguration } from '../../environments/models/environment.model';
import { Notification } from '../models/notification';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private httpClient = inject(HttpClient);
  environment = inject<EnvironmentConfiguration>(ENVIRONMENT_CONFIG);

  baseUrl = "";
  constructor() {
    this.baseUrl = this.environment.serviceCall.baseURL!;
    this.baseUrl = this.baseUrl.slice(-1) === '/' ? this.baseUrl : this.baseUrl + '/';
    this.baseUrl = `${this.baseUrl}notification`;
  }

  getNotifications(): Observable<Notification[]> {
    return this.httpClient.get<Notification[]>(this.baseUrl);
  }

  getNotification(id: string): Observable<Notification> {
    return this.httpClient.get<Notification>(`${this.baseUrl}/${id}`);
  }
}
